import {JOB_LIST} from '../testing/TestingDataSH26';

// helper functions

function FilterJobs(type) {
    return JOB_LIST.filter(function (job) {
        return job.adminStatus === type;
    })
}

function GetFullList(type1, type2) {
    return JOB_LIST.filter(function (job) {
        return job.adminStatus === type1 || job.adminStatus === type2;
    })
}

function FilterJobsYear(type, year) {
    return JOB_LIST.filter(function (job) {
        return job.adminStatus === type && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function FilterJobsMonth(type, month, year) {
    return JOB_LIST.filter(function (job) {
        return job.adminStatus === type && new Date(job.dates.enquiryReceived).getMonth() === month
            && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function countJobs() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    return {
        currentJobCountYear: FilterJobsYear("UNAPPROVED", year).length,
        completeJobCountYear: FilterJobsYear("APPROVED", year).length,

        currentJobCountMonth: FilterJobsMonth("UNAPPROVED", month, year).length,
        completeJobCountMonth: FilterJobsMonth("APPROVED", month, year).length,
    }
}

// reducers

export function jobCountSkimReducer(state = countJobs(), action) {
    switch (action.type) {
        case 'admin/jobCountSkimReducer/UPDATE':
            return countJobs();
        default:
            return state;
    }
}

export function SortReducerIncomplete(state, action) {
    switch (action.type) {
        case 'admin/jobSort/SORT_NEW':
            let jobsList = FilterJobs("UNAPPROVED");
            jobsList.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
          
            return jobsList;
        case 'admin/jobSort/SORT_OLD':
            let jobsListOldest = FilterJobs("UNAPPROVED");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'admin/jobSort/SORT_AZ':
            let jobsListAZ = FilterJobs("UNAPPROVED");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
           
            return FilterJobs("UNAPPROVED");
    }
}

export function SortReducerComplete(state, action, jobType) {
    switch (action.type) {
        case 'admin/jobSort/SORT_NEW':
            let jobsListNew = FilterJobs("APPROVED");
            jobsListNew.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListNew;
        case 'admin/jobSort/SORT_OLD':
            let jobsListOldest = FilterJobs("APPROVED");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'admin/jobSort/SORT_AZ':
            let jobsListAZ = FilterJobs("APPROVED");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return FilterJobs("APPROVED");
    }
}

export function SortReducerFull(state, action, jobType) {
    switch (action.type) {
        case 'admin/jobSort/SORT_NEW':
            let jobsListNew = GetFullList("APPROVED", "UNAPPROVED");
            jobsListNew.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListNew;
        case 'admin/jobSort/SORT_OLD':
            let jobsListOldest = GetFullList("APPROVED", "UNAPPROVED");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'admin/jobSort/SORT_AZ':
            let jobsListAZ = GetFullList("APPROVED", "UNAPPROVED");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return GetFullList("APPROVED", "UNAPPROVED");
    }
}


export function SearchReducerNew(state = "search", action) {
    switch (action.type) {
        case 'admin/new/SEARCH': {
            let returnList = []
            let jobs = FilterJobs(action.jobType)
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function SearchReducerComplete(state = "search", action) {
    switch (action.type) {
        case 'admin/complete/SEARCH': {
            let returnList = []
            let jobs = FilterJobs("APPROVED")
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function SearchReducerFull(state = "search", action) {
    switch (action.type) {
        case 'admin/full/SEARCH': {
            let returnList = []
            let jobs = GetFullList("APPROVED", "UNAPPROVED");
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}